import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { environmentbasic } from '../../environments/environment-basic';
import Swal from 'sweetalert2';
import { ModalService } from '../modal.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  email: string = '';

  constructor(
    private router: Router, private homeService: HomeService,private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }
  navigateTOcontactUs() {
    this.router.navigate(['/contactUs']);
  }

  submitEmail() {
    const payload = {
      email: this.email,
      projectName: 'fuprop'
    };
    console.log('Payload:', payload);

    this.homeService.onService(payload).subscribe(
      (res: any) => {
        if (res.status === 'SUCCESS') {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Email submitted successfully!',
            showConfirmButton: false,
            timer: environmentbasic.timer
          });
          this.email = '';
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Warning',
            text: res.message || 'Something went wrong.',
            showConfirmButton: false,
            timer: environmentbasic.timer
          });
        }
      },
      (error) => {
        console.error('API Error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to submit email. Please try again later.',

        });
      }
    );
  }
  openServiceRequest(service: string) {
    this.modalService.openModal(service);
  }

}
